module.exports = __webpack_public_path__ + "img/inspiring.c2d7d21b.png";